export default "/packs/87dc1309d79391575a8de3c62c3e0bb5.svg";